export default __webpack_public_path__ + "static/media/notFound.715c50fe.png";